import { render, staticRenderFns } from "./JsonSchemaTreeItem.vue?vue&type=template&id=37242881&"
import script from "./JsonSchemaTreeItem.vue?vue&type=script&lang=js&"
export * from "./JsonSchemaTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./JsonSchemaTreeItem.vue?vue&type=style&index=0&id=37242881&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports